import {createAction, createReducer} from '@reduxjs/toolkit';
import {ServiceProvider, UserInfoResponse} from '~/entities/user';

type State = UserInfoResponse | null | undefined;
type ProviderStatus = UserInfoResponse['serviceProviders'][number]['status'];

const actions = {
    securitiesLTDRequested: createAction('user-info/securitiesLTDRequested', (nextStatus: ProviderStatus) => ({
        payload: nextStatus,
    })),
};

const reducer = createReducer<State>(null, builder => {
    builder.addCase(actions.securitiesLTDRequested, state => {
        const securitiesLTD = state?.serviceProviders.find(
            sp => sp.serviceProvider === ServiceProvider.RaisonSecuritiesLTD
        );
        if (securitiesLTD) {
            securitiesLTD.status = 'requested';
        }
    });
});

export const updateUserInfo = {
    securitiesLTDRequested: (state: State, ...params: Parameters<typeof actions.securitiesLTDRequested>) => {
        return reducer(state, actions.securitiesLTDRequested(...params)) ?? undefined;
    },
};
